import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'etxe-property-creation-how-to',
  imports: [CommonModule, MatButtonModule, MatIconModule],
  templateUrl: './creation-how-to.component.html',
  styles: [
    `
      :host {
        display: block;
      }
      .shadow-soft {
        box-shadow: 0 20px 60px -10px rgba(0, 0, 0, 0.08);
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertyCreationProcessComponent {
  startClicked = output<void>();
  backClicked = output<void>();
}
